import { render } from "./MessageWrapper.vue?vue&type=template&id=2179f61c&scoped=true&ts=true"
import script from "./MessageWrapper.vue?vue&type=script&lang=ts"
export * from "./MessageWrapper.vue?vue&type=script&lang=ts"

import "./MessageWrapper.vue?vue&type=style&index=0&id=2179f61c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2179f61c"]])

export default __exports__